(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 83236:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(45170);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ login; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./components/utils.ts
var utils = __webpack_require__(90759);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 6 modules
var useCookies = __webpack_require__(70461);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./lib/gtag.ts
var gtag = __webpack_require__(85657);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/permissions.ts
var permissions = __webpack_require__(13677);
// EXTERNAL MODULE: ./node_modules/universal-cookie/lib/utils.js
var lib_utils = __webpack_require__(51148);
;// CONCATENATED MODULE: ./components/common/LoginView.tsx











var LoginView = function(props) {
    var redirectToUserPage = function redirectToUserPage(cookie) {
        if (cookie && cookie["permissions"]) {
            if (cookie["role"] == "admin") {
                window.location.href = window.location.origin + "/admin";
            } else if ((0,permissions/* hasPermissionsForManagePage */.zZ)(cookie)) {
                window.location.href = window.location.origin + "/eadmin";
            } else if ((0,permissions/* hasPermissions */.qX)(cookie, permissions/* CLIENT */.ID)) {
                window.location.href = window.location.origin + "/client";
            } else if ((0,permissions/* hasPermissions */.qX)(cookie, permissions/* OPD */.tv)) {
                window.location.href = window.location.origin + "/opd";
            } else if ((0,permissions/* hasPermissions */.qX)(cookie, permissions/* IPD */._x)) {
                window.location.href = window.location.origin + "/ipd";
            } else if ((0,permissions/* hasPermissions */.qX)(cookie, permissions/* RADIOLOGY */.y5)) {
                window.location.href = window.location.origin + "/radiology";
            } else if ((0,permissions/* hasPermissions */.qX)(cookie, permissions/* INVENTORY */.Qy) || (0,permissions/* hasPermissions */.qX)(cookie, permissions/* BILLING */.XT)) {
                window.location.href = window.location.origin + "/inventory";
            } else if ((0,permissions/* hasPermissions */.qX)(cookie, permissions/* LAB */.VI)) {
                window.location.href = window.location.origin + "/lab";
            } else if ((0,permissions/* hasPermissions */.qX)(cookie, permissions/* OPHTHALMOLOGY */.Z6)) {
                window.location.href = window.location.origin + "/ophthalmology";
            } else {
                window.location.href = window.location.origin;
            }
        }
    };
    var loginToEntity = function loginToEntity(qrCode, entityQr, userName, userId, entity, permissions) {
        if (entity) {
            localStorage.setItem("opd", entity.qmeEnabled);
            localStorage.setItem("ipd", entity.ipdEnabled);
            localStorage.setItem("inventory", entity.inventoryEnabled);
            localStorage.setItem("radiology", entity.radiologyEnabled);
            localStorage.setItem("lab", entity.labEnabled);
        } else {
            localStorage.setItem("opd", "true");
            localStorage.setItem("ipd", "true");
        }
        localStorage.setItem("role", role);
        if (role == "client") {
            var cookie = {
                "role": "client",
                "phone": mobileNumber,
                "active": false,
                "qr": qrCode,
                "entity_qr": entityQr,
                "name": userName,
                "id": userId,
                "permissions": permissions
            };
            setCookie("qme", cookie, {
                maxAge: 2630000
            });
            redirectToUserPage(cookie);
        } else {
            var cookie1 = {
                "role": role,
                "phone": mobileNumber,
                "entity_qr": entityQr,
                "name": userName,
                "id": userId,
                "permissions": permissions
            };
            setCookie("qme", cookie1, {
                maxAge: 2630000
            });
            redirectToUserPage(cookie1);
        }
    };
    var getLoginDetails = function getLoginDetails() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !authenticated && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "py-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-primary fs-5 mb-3",
                            children: "Clinic & Hospital User Login"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                            className: "form-select mb-3",
                            value: role,
                            onChange: function(e) {
                                setRole(e.target.value);
                                setOtpGenerated(false);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "client",
                                    children: "Doctor"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "entity_admin",
                                    children: "Hospital Admin"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "fd_exec",
                                    children: "Front Desk"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "opd_manager",
                                    children: "OPD Manager"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "ipd_executive",
                                    children: "IPD Executive"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "ipd_manager",
                                    children: "IPD Manager"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "nursing_staff",
                                    children: "Nursing Staff"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "inv_manager",
                                    children: "Pharmacy Manager"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "sales_exec",
                                    children: "Pharmacy Billing Executive"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "lab_manager",
                                    children: "Lab Manager"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "radiologist",
                                    children: "Radiologist"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "ophthalmic_technician",
                                    children: "Ophthalmic Technician"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "custom_role",
                                    children: "Custom Role"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "admin",
                                    children: "Admin"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "input-group mb-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "input-group-prepend",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "input-group-text",
                                        id: "basic-addon1",
                                        children: "+91 -"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "tel",
                                    placeholder: "Enter phone number",
                                    onChange: function(e) {
                                        setMobileNumber(e.target.value);
                                        setOtpGenerated(false);
                                    },
                                    className: "form-control"
                                })
                            ]
                        }),
                        !otpGenerated && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            onClick: onFinish,
                            className: "form-control btn btn-info",
                            children: [
                                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "spinner-border",
                                        role: "status"
                                    })
                                }),
                                !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-white",
                                    children: "Generate OTP"
                                })
                            ]
                        }),
                        otpGenerated && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "tel",
                                    maxLength: 6,
                                    placeholder: "Enter OTP",
                                    onChange: function(e) {
                                        return setEnteredOtp(e.target.value);
                                    },
                                    className: "form-control my-3"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: onFinish,
                                    className: "form-control btn btn-info",
                                    children: [
                                        loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "spinner-border",
                                                role: "status"
                                            })
                                        }),
                                        !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-white",
                                            children: "Login"
                                        })
                                    ]
                                })
                            ]
                        }),
                        error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "my-3 text-danger fs-6",
                            children: error
                        })
                    ]
                }),
                authenticated && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-2 text-secondary",
                            children: "Please Select the Clinic/Hospital"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                            className: "form-select mb-3",
                            value: hospitalSelection,
                            onChange: function(e) {
                                setHospitalSelection(e.target.value);
                            },
                            children: hospitalOptions.map(function(opt) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: opt.entityQr,
                                    children: opt.name
                                }, opt);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: handleSelectEntity,
                            className: "form-control btn btn-info",
                            children: " Login"
                        })
                    ]
                })
            ]
        });
    };
    var ref = (0,react.useState)(null), error = ref[0], setError = ref[1];
    var ref1 = (0,react.useState)(false), otpGenerated = ref1[0], setOtpGenerated = ref1[1];
    var ref2 = (0,react.useState)(false), authenticated = ref2[0], setAuthenticated = ref2[1];
    var ref3 = (0,react.useState)([]), hospitalOptions = ref3[0], setHospitalOptions = ref3[1];
    var ref4 = (0,react.useState)(), hospitalSelection = ref4[0], setHospitalSelection = ref4[1];
    var ref5 = (0,react.useState)(), userName = ref5[0], setUserName = ref5[1];
    var ref6 = (0,react.useState)(), userId = ref6[0], setUserId = ref6[1];
    var ref7 = (0,react.useState)(null), mobileNumber = ref7[0], setMobileNumber = ref7[1];
    var ref8 = (0,react.useState)(null), enteredOtp = ref8[0], setEnteredOtp = ref8[1];
    var ref9 = (0,react.useState)("client"), role = ref9[0], setRole = ref9[1];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,useCookies/* default */.Z)([
        "qme",
        "token"
    ]), 2), cookies = ref10[0], setCookie = ref10[1];
    var ref11 = (0,react.useState)(false), loading = ref11[0], setLoading = ref11[1];
    var router = (0,next_router.useRouter)();
    var handleSelectEntity = function(e) {
        e.preventDefault();
        var hospital = hospitalOptions.filter(function(ho) {
            return ho.entityQr == hospitalSelection;
        })[0];
        loginToEntity(hospital.qr, hospitalSelection, userName, userId, hospital.entity, hospital.permissions);
    };
    var onFinish = function(e) {
        e.preventDefault();
        if (!otpGenerated) {
            if (!(0,utils/* validatePhoneNumber */.Y0)(mobileNumber)) {
                setError("* Please provide correct mobile number");
                return;
            } else {
                setError(null);
            }
            setLoading(true);
            axios_default().post("/api/backend/user/send/otp", {
                mobile: mobileNumber,
                role: role
            }).then(function(resp) {
                if (resp.data) {
                    setOtpGenerated(true);
                } else {
                    setError("* User not found. Please use registered mobile number");
                }
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
            }).finally(function() {
                return setLoading(false);
            });
        } else {
            setLoading(true);
            axios_default().post("/api/backend/user/validate/otp", {
                mobile: mobileNumber,
                otp: enteredOtp,
                role: role
            }).then(function(resp) {
                if (!resp.data.valid) {
                    setError("* Incorrect OTP");
                    return;
                } else {
                    setError(null);
                }
                gtag/* event */.B({
                    action: "login-triggered",
                    params: {
                        mobile: mobileNumber,
                        role: role
                    }
                });
                console.log("taking to role page");
                setCookie("token", resp.data.token, {
                    maxAge: 2630000
                });
                if (role == "admin") {
                    localStorage.setItem("opd", "true");
                    localStorage.setItem("ipd", "true");
                    localStorage.setItem("inventory", "true");
                    localStorage.setItem("radiology", "true");
                    localStorage.setItem("lab", "true");
                    setCookie("qme", {
                        "role": "admin",
                        "phone": mobileNumber,
                        "name": resp.data.qrVsName[0].userName,
                        "id": resp.data.qrVsName[0].userId,
                        "permissions": resp.data.qrVsName[0].permissions
                    }, {
                        maxAge: 2630000
                    });
                    window.location.href = window.location.origin + "/admin";
                }
                if (resp.data.qrVsName.length == 1) {
                    loginToEntity(resp.data.qrVsName[0].qr, resp.data.qrVsName[0].entityQr, resp.data.qrVsName[0].userName, resp.data.qrVsName[0].userId, resp.data.qrVsName[0].entity, resp.data.qrVsName[0].permissions);
                } else {
                    setAuthenticated(true);
                    setHospitalOptions(resp.data.qrVsName);
                    setHospitalSelection(resp.data.qrVsName[0].entityQr);
                    setUserName(resp.data.qrVsName[0].userName);
                    setUserId(resp.data.qrVsName[0].userId);
                }
            }).catch(function(err) {
                setError(null);
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    setError(err.response.data);
                    //handleLogout()
                    (0,lib_utils/* cleanCookies */.XS)();
                }
            }).finally(function() {
                return setLoading(false);
            });
        }
    };
    var onFinishFailed = function(errorInfo) {
        console.log("Failed:", errorInfo);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "row",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "col col-md-6 offset-md-3 d-grid pt-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                    className: "card shadow p-5 d-none d-md-block",
                    children: getLoginDetails()
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                    className: "px-3 d-md-none",
                    children: getLoginDetails()
                })
            ]
        })
    });
};
/* harmony default export */ var common_LoginView = (LoginView);

// EXTERNAL MODULE: ./components/common/Footer.tsx
var Footer = __webpack_require__(26123);
;// CONCATENATED MODULE: ./pages/login.tsx






var Login = function(props) {
    var router = (0,next_router.useRouter)();
    var forLogin = router.query["for"] ? router.query["for"].toString() : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "QMe - Clinic/Hospital Management | Login"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.qme.co.in/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "/og.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Effortless Patient Management & Token-Based Appointments | QME"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: "Experience efficient stock control, innovative token-based scheduling, and smart queues for unparalleled patient experiences at QME. Read for more!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: "/og.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "index, follow"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify({
                                "@context": "https://schema.org",
                                "@type": "Organization",
                                "name": "QMe - Hospital and Clinic Management",
                                "image": "https://www.qme.co.in/logo.svg",
                                "description": "Effortless patient management, efficient stock and inventory control, unparalleled patient experience through innovative token-based appointments and smart queues and much more.",
                                "url": "https://www.qme.co.in/",
                                "telephone": "+919971513514",
                                "emailid": "contact@qme.co.in",
                                "sameAs": [
                                    "https://www.facebook.com/qmehmis",
                                    "https://www.instagram.com/qmehmis",
                                    "https://www.youtube.com/@qmehmis"
                                ]
                            }, null, "	")
                        }
                    }, "schema-jsonld"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "QMe - Clinic/Hospital Management | Login"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "electronic medical records software, emr, ehr"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_LoginView, {
                            for: forLogin
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var login = (Login);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9669,7847,4035,6123,9774,2888,179], function() { return __webpack_exec__(83236); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);